import { Box, Text } from '@chakra-ui/react';

interface Props {
  block: {
    type: number;
    label: string;
    options: Map<string, string>;
  };
  content: string[];
  hideLabel?: boolean;
}

// Stable pastel palette per field, hashed from the label so the same
// field always gets the same color across renders.
const PALETTES = ['green', 'blue', 'orange', 'purple', 'cyan', 'pink', 'yellow', 'red'];
function paletteFor(label: string): string {
  let h = 0;
  for (let i = 0; i < label.length; i++) h = (h * 31 + label.charCodeAt(i)) >>> 0;
  return PALETTES[h % PALETTES.length];
}

export default function SelectionBlock({ block, content, hideLabel = false }: Props) {
  const values = Array.isArray(content)
    ? content.map((item) => block.options.get(item) ?? item)
    : [];

  if (values.length === 0) return null;

  const palette = paletteFor(block.label || 'field');
  const display = values.join(', ');

  return (
    <Box
      display='inline-flex'
      alignItems='center'
      gap={1.5}
      px={2.5}
      py={1}
      borderRadius='full'
      bg={`${palette}.50`}
      borderWidth='1px'
      borderColor={`${palette}.200`}
      lineHeight={1.2}
    >
      {!hideLabel && (
        <Text
          fontSize='2xs'
          textTransform='uppercase'
          letterSpacing='wider'
          color={`${palette}.700`}
          fontWeight='semibold'
        >
          {block.label}
        </Text>
      )}
      <Text fontSize='xs' fontWeight='semibold' color='gray.900'>
        {display}
      </Text>
    </Box>
  );
}
